module.exports = __webpack_public_path__ + "static/media/payment-manabie-confirm.09c866ca.png";